import 'antd/dist/reset.css';

import { store } from '@core/redux/store';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { setLocale } from 'yup';

import App from 'src/app/App';

import yupBrazilianLocale from './app/utils/yupBrazilianLocale';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://4738c076878c46578e87dc0d4dfc15b1@o530768.ingest.sentry.io/4504129460109312',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.015,
});

async function startApplication() {
  if (process.env.NODE_ENV === 'development') {
    const { initTemporaryBenefitsMock } = await import(
      './mocks/temporary/initTemporaryBenefitsMock'
    );
    await initTemporaryBenefitsMock();
  }

  setLocale(yupBrazilianLocale);

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

startApplication();

reportWebVitals();
